import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AntecedentValueCheckService {
  private readonly API_URL = `${environment.apiUrl}/es/Appraisals/InsertAntecedentForValueCheck`;

  constructor(private http: HttpClient) {}

  insertAntecedentForValueCheck(excelFile: File): Observable<any> {
    const formData = new FormData();
    formData.append('excelFile', excelFile, excelFile.name);
    return this.http.post(this.API_URL, formData);
  }
}
